<script>
import BasePriority from '@/components/BasePriority.vue';
import BaseStatus from '@/components/BaseStatus.vue';
import UserUniversalTile from '@/components/UserUniversalTile.vue';

export default {
  name: 'TaskRow',
  components: { BaseStatus, UserUniversalTile, BasePriority },
  props: {
    task: Object,
    editable: Boolean,
    to: Object,
    projectMembers: Array,
  },
  methods: {
    update(field, value) {
      const { id } = this.task;
      this.$emit('update', { id, field, value });
    },
  },
};
</script>

<template lang="pug">
  .task-row
    Link.name(v-if="to" :to="to" target='_blank') {{ task.name }}
    .name(v-else) {{ task.name }}
    BaseStatus.status(:status="task.status" :gray="task.isClosed")
    BasePriority(:editable="editable" :level="task.priority" :gray="task.isClosed" @change="update('priority', $event)")
    UserUniversalTile._task-manager(
      :selected="task.manager"
      :editable="editable"
      :items="projectMembers"
      short
      @change="update('manager', $event)"
      :size="24"
    )
</template>

<style scoped lang="scss">
.task-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  background: #EBF1F7;
  border-radius: 4px;
  padding: 0 16px;
  position: relative;
  gap: 12px;
}

.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: #1E3147;
  max-width: 240px;
  margin-right: auto;
}

.task-row .status {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  min-width: 4px;
  font-size: 0 !important;
  padding: 0;
}
</style>
